export default __webpack_public_path__ + "static/media/pyesu_stop_overlay.f3006c39.svg";